
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.375 5.25c3.52 0 6.375-1.175 6.375-2.625S9.896 0 6.375 0C2.855 0 0 1.175 0 2.625S2.854 5.25 6.375 5.25zM5.558 8.976a7.153 7.153 0 012.17-2.665c-.448.039-.9.064-1.353.064C3.892 6.375 1.395 5.8 0 4.69v1.685C0 7.711 2.424 8.81 5.558 8.976zM4.875 12c0-.67.099-1.314.272-1.928C3.097 9.914 1.163 9.366 0 8.439v1.686c0 1.242 2.096 2.279 4.91 2.552A7.209 7.209 0 014.875 12zM12 6C8.692 6 6 8.69 6 12c0 3.308 2.692 6 6 6s6-2.692 6-6c0-3.309-2.692-6-6-6zm-.285 5.437h.57a1.592 1.592 0 01.277 3.159v.59a.563.563 0 01-1.124 0v-.562h-.75a.563.563 0 010-1.125h1.597a.465.465 0 00.465-.465.467.467 0 00-.465-.472h-.57a1.592 1.592 0 01-.277-3.159v-.591a.563.563 0 011.124 0v.563h.75a.563.563 0 010 1.124h-1.597a.465.465 0 00-.465.465c0 .264.209.473.465.473z","fill":"#fff"}})])
          )
        }
      }
    